import script from "./TopicEdit.vue?vue&type=script&setup=true&lang=ts"
export * from "./TopicEdit.vue?vue&type=script&setup=true&lang=ts"

import "./TopicEdit.vue?vue&type=style&index=0&id=d842735e&lang=stylus&scoped=true"

import exportComponent from "/www/wwwroot/home/v-admin/node_modules/.store/vue-loader@16.8.3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d842735e"]])

export default __exports__